<template>
  <div>
    <v-row align="end" class="mb-4">
      <v-col cols="auto" class="d-flex align-center">
        <shift-picker v-model="selectedShifts" multiple />
      </v-col>
    </v-row>
    <v-row justify="center" class="py-15" no-gutters v-if="loading">
      <v-col cols="auto">
        <v-progress-circular indeterminate color="primary"></v-progress-circular>
      </v-col>
    </v-row>
    <template v-else>
      <div class="mt-6" v-for="company in filteredCompanies">
        <h1 class="text-center">{{ toLatin(company.name) }}</h1>
        <h3
          class="text-center"
          v-if="
            company.users.every(
              (user) =>
                !(selectedShifts.includes(1) && user.shift1?.meals?.length > 0) &&
                !(selectedShifts.includes(2) && user.shift2?.meals?.length > 0) &&
                !(selectedShifts.includes(3) && user.shift3?.meals?.length > 0) &&
                !(selectedShifts.includes(4) && user.shift4?.meals?.length > 0)
            )
          "
        >
          {{ $t("no_orders") }}
        </h3>
        <v-row
          v-for="shift in [
            { name: 'shift1', label: $t('shift_one'), number: 1 },
            { name: 'shift2', label: $t('shift_two'), number: 2 },
            { name: 'shift3', label: $t('shift_three'), number: 3 },
            { name: 'shift4', label: $t('shift_four'), number: 4 },
          ]"
          :key="shift.name"
          v-if="
            selectedShifts.includes(shift.number) &&
            company.users.some((user) => user[shift.name].meals.length > 0)
          "
        >
          <v-col cols="12">
            <h2 class="text-center">{{ shift.label }}</h2>
          </v-col>
          <v-col
            cols="12"
            lg="3"
            v-for="user in company.users"
            v-if="user[shift.name].meals.length > 0"
            :key="user.id"
          >
            <div
              class="fill-height"
              style="border: 1px solid #ccc; padding: 16px; margin-bottom: 16px"
            >
              <!-- <p class="text-center">{{ user.id }}</p> -->
              <h3 class="text-center">
                {{ toLatin(user.name) }} {{ toLatin(user.lastname) }}
              </h3>
              <div v-for="meal in user[shift.name].meals" :key="meal.id" class="mt-3">
                <strong>{{ meal.quantity }}x </strong>{{ toLatin(meal.name) }}
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </template>
  </div>
</template>

<script>
import reportService from "@/services/report";
import hasPrinting from "@/mixins/hasPrinting";
import hasExcel from "@/mixins/hasExcel";
import hasReportPrinting from "@/mixins/report/hasReportPrinting";

export default {
  name: "CompanyReportTabOrders",
  mixins: [hasPrinting, hasExcel, hasReportPrinting],
  data() {
    return {
      report: null,
      loading: false,
      selectedShifts: [1, 2, 3, 4], // Po default sve četiri smene
    };
  },
  created() {
    this.fetchOrders();
  },
  methods: {
    fetchOrders() {
      this.loading = true;
      reportService
        .getCompanyUserlist({
          company_id: this.selectedCompanies,
          date: this.dates.from,
          date2: this.dates.to,
        })
        .then((response) => {
          this.report = response.data;
        })
        .catch((error) => {
          console.error("Error fetching meals:", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  computed: {
    search() {
      return this.$store.state.report.filters.search;
    },
    companies() {
      if (!this.report) {
        return [];
      }

      return Object.entries(this.report).map(([companyName, companyData]) => {
        const userMap = new Map();
        const companyTotals = {
          shift1: 0,
          shift2: 0,
          shift3: 0,
          shift4: 0,
          total: 0,
        };

        (companyData.meals || [])
          .filter((meal) => meal.total > 0 && meal.id)
          .forEach((meal) => {
            Object.entries(meal.users || {}).forEach(([shiftKey, usersInShift]) => {
              (usersInShift || []).forEach((user) => {
                let userRecord = userMap.get(user.id);
                if (!userRecord) {
                  userRecord = {
                    id: user.id,
                    name: user.name,
                    lastname: user.lastname,
                    shift1: { meals: [] },
                    shift2: { meals: [] },
                    shift3: { meals: [] },
                    shift4: { meals: [] },
                  };
                  userMap.set(user.id, userRecord);
                }

                if (shiftKey === "1-smena") {
                  const existingMeal = userRecord.shift1.meals.find(
                    (m) => m.id === meal.id
                  );
                  if (existingMeal) {
                    existingMeal.quantity += user.quantity;
                  } else {
                    userRecord.shift1.meals.push({
                      ...meal,
                      quantity: user.quantity,
                    });
                  }
                } else if (shiftKey === "2-smena") {
                  const existingMeal = userRecord.shift2.meals.find(
                    (m) => m.id === meal.id
                  );
                  if (existingMeal) {
                    existingMeal.quantity += user.quantity;
                  } else {
                    userRecord.shift2.meals.push({
                      ...meal,
                      quantity: user.quantity,
                    });
                  }
                } else if (shiftKey === "3-smena") {
                  const existingMeal = userRecord.shift3.meals.find(
                    (m) => m.id === meal.id
                  );
                  if (existingMeal) {
                    existingMeal.quantity += user.quantity;
                  } else {
                    userRecord.shift3.meals.push({
                      ...meal,
                      quantity: user.quantity,
                    });
                  }
                } else if (shiftKey === "4-smena") {
                  const existingMeal = userRecord.shift4.meals.find(
                    (m) => m.id === meal.id
                  );
                  if (existingMeal) {
                    existingMeal.quantity += user.quantity;
                  } else {
                    userRecord.shift4.meals.push({
                      ...meal,
                      quantity: user.quantity,
                    });
                  }
                }
              });
            });
          });
        companyTotals.total =
          companyTotals.shift1 +
          companyTotals.shift2 +
          companyTotals.shift3 +
          companyTotals.shift4;
        return {
          name: companyName,
          users: Array.from(userMap.values()),
          totals: companyTotals,
        };
      });
    },
    filteredCompanies() {
      if (!this.search) {
        return this.companies;
      }

      const searchTerm = this.translate(this.search.toLowerCase());

      return this.companies
        .map((company) => ({
          ...company,
          users: (company.users || []).filter((user) => {
            const fullName = `${user.name} ${user.lastname}`.toLowerCase();
            return (
              this.translate(fullName).includes(searchTerm) ||
              this.translate(user.name).includes(searchTerm) ||
              this.translate(user.lastname).includes(searchTerm)
            );
          }),
        }))
        .filter((company) => (company.users || []).length > 0);
    },
    selectedCompanies() {
      return this.$store.state.report.selectedFoodCompanies.map((company) => company.id);
    },
    dates() {
      return this.$store.state.report.filters.dates;
    },
  },
  watch: {
    selectedCompanies() {
      this.fetchOrders();
    },
    "dates.from"(newVal, oldVal) {
      this.fetchOrders();
    },
    isExcelDownloading() {
      if (this.isExcelDownloading) {
        this.downloadExcel({
          fileName: [this.$t("report"), this.$t("employees")].join(" ") + ".xlsx",
          sheets: this.filteredCompanies.map((company) => {
            return {
              name: company.name,
              headers: [
                { text: this.$t("name"), value: "name" },
                ...(this.selectedShifts.includes(1)
                  ? [{ value: "shift1", text: this.$t("shift_one") }]
                  : []),
                ...(this.selectedShifts.includes(2)
                  ? [{ value: "shift2", text: this.$t("shift_two") }]
                  : []),
                ...(this.selectedShifts.includes(3)
                  ? [{ value: "shift3", text: this.$t("shift_three") }]
                  : []),
                ...(this.selectedShifts.includes(4)
                  ? [{ value: "shift4", text: this.$t("shift_four") }]
                  : []),
              ],
              items: (() => {
                // For each user, flatten all meals into rows, one meal per row, with name only in first cell (rowspan in Excel)
                const rows = [];
                company.users.forEach((user) => {
                  // Collect all meals with shift info
                  const mealRows = [];
                  [
                    { key: "shift1", col: "shift1", number: 1 },
                    { key: "shift2", col: "shift2", number: 2 },
                    { key: "shift3", col: "shift3", number: 3 },
                    { key: "shift4", col: "shift4", number: 4 },
                  ]
                    .filter((shift) => this.selectedShifts.includes(shift.number))
                    .forEach(({ key, col }) => {
                      (user[key].meals || []).forEach((meal) => {
                        const mealText = `${meal.quantity}x ${this.toLatin(meal.name)}`;
                        const row = {
                          name: [user.name, user.lastname].join(" "),
                        };

                        // Only add columns for selected shifts
                        if (this.selectedShifts.includes(1)) {
                          row.shift1 = col === "shift1" ? mealText : "";
                        }
                        if (this.selectedShifts.includes(2)) {
                          row.shift2 = col === "shift2" ? mealText : "";
                        }
                        if (this.selectedShifts.includes(3)) {
                          row.shift3 = col === "shift3" ? mealText : "";
                        }
                        if (this.selectedShifts.includes(4)) {
                          row.shift4 = col === "shift4" ? mealText : "";
                        }

                        mealRows.push(row);
                      });
                    });
                  if (mealRows.length === 0) {
                    // User with no meals, add empty row
                    const emptyRow = {
                      name: [user.name, user.lastname].join(" "),
                    };

                    // Only add columns for selected shifts
                    if (this.selectedShifts.includes(1)) {
                      emptyRow.shift1 = "";
                    }
                    if (this.selectedShifts.includes(2)) {
                      emptyRow.shift2 = "";
                    }
                    if (this.selectedShifts.includes(3)) {
                      emptyRow.shift3 = "";
                    }
                    if (this.selectedShifts.includes(4)) {
                      emptyRow.shift4 = "";
                    }

                    mealRows.push(emptyRow);
                  }
                  // For Excel vertical merge, only first row gets rowspans, others get empty name
                  mealRows.forEach((row, idx) => {
                    if (idx === 0 && mealRows.length > 1) {
                      row.colspans = [
                        {
                          col: "name",
                          colspan: mealRows.length,
                        },
                      ];
                    } else if (idx > 0) {
                      row.name = "";
                    }
                  });
                  rows.push(...mealRows);
                });
                return rows;
              })(),
              title: company.name,
              subtitle: this.subtitle,
            };
          }),
        });
      }
    },
    isPrinting() {
      if (this.isPrinting) {
        let appendHtml = `<div style='display: flex;flex-wrap: wrap;'>`;
        this.filteredCompanies.forEach((company) => {
          appendHtml += `<h2 style='width: 100%; text-align: center;'>${company.name}</h2>`;
          if (
            company.users.every(
              (user) =>
                !(selectedShifts.includes(1) && user.shift1?.meals?.length > 0) &&
                !(selectedShifts.includes(2) && user.shift2?.meals?.length > 0) &&
                !(selectedShifts.includes(3) && user.shift3?.meals?.length > 0) &&
                !(selectedShifts.includes(4) && user.shift4?.meals?.length > 0)
            )
          ) {
            appendHtml += `<p style='width: 100%; text-align: center;'>${this.$t(
              "no_orders"
            )}</p>`;
          }
          [
            { name: "shift1", label: this.$t("shift_one"), number: 1 },
            { name: "shift2", label: this.$t("shift_two"), number: 2 },
            { name: "shift3", label: this.$t("shift_three"), number: 3 },
            { name: "shift4", label: this.$t("shift_four"), number: 4 },
          ]
            .filter((shift) => this.selectedShifts.includes(shift.number))
            .forEach((shift) => {
              const usersWithMeals = company.users.filter(
                (user) => user[shift.name].meals.length > 0
              );
              if (usersWithMeals.length > 0) {
                appendHtml += `<h3 style='width: 100%; text-align: center;'>${shift.label}</h3>`;
              }
              usersWithMeals.forEach((user) => {
                appendHtml += `<div style='flex: 0 0 50%;box-sizing: border-box;padding: 12px;border: 1px solid #ccc;'>
                <h4 style="text-align:center;margin-top: 0">${this.toLatin(
                  user.name
                )} ${this.toLatin(user.lastname)}</h4>`;
                user[shift.name].meals.forEach((meal) => {
                  appendHtml += `<p>${meal.quantity}x ${this.toLatin(meal.name)}</p>`;
                });
                appendHtml += `</div>`;
              });
            });
        });
        appendHtml += `</div>`;
        this.printDocument({
          title: [this.$t("report"), this.$t("orders")].join(" "),
          afterTableHtml: appendHtml,
          subtitle: this.subtitle,
        });
      }
    },
  },
};
</script>
